import { render, staticRenderFns } from "./signatureApproveDetails.vue?vue&type=template&id=0889d341&scoped=true&"
import script from "./signatureApproveDetails.vue?vue&type=script&lang=js&"
export * from "./signatureApproveDetails.vue?vue&type=script&lang=js&"
import style0 from "./signatureApproveDetails.vue?vue&type=style&index=0&id=0889d341&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889d341",
  null
  
)

export default component.exports